<template>
  <div class="alert-dialog-header">
    <slot />
  </div>
</template>

<script setup lang="ts">
// Add your component logic here
</script>

<style scoped>
.alert-dialog-header {
  /* Add your styles here */
}
</style>
